import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export function NotFoundPage({ slug }) {
  return (
    <>
      <Helmet>
        <title>Page not found — Maple Leaf International School</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <section style={{ padding: '120px 0 100px', textAlign: 'center' }}>
        <div className="container" style={{ maxWidth: 640 }}>
          <div className="section-eyebrow" style={{ display: 'inline-block', color: 'var(--gold-700)' }}>404</div>
          <h1 className="welcome-title" style={{ marginTop: 18 }}>
            We couldn't find <em style={{ color: 'var(--green-700)' }}>that page</em>
          </h1>
          {slug && (
            <p style={{ color: 'var(--ink-3)', marginTop: 12, fontSize: 14 }}>
              <code style={{ background: 'var(--cream)', padding: '2px 8px', borderRadius: 4 }}>/page/{slug}</code> doesn't exist.
            </p>
          )}
          <p className="welcome-lede" style={{ marginTop: 18 }}>
            The link you followed may be broken, or the page may have been moved. Try one of these instead:
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap', marginTop: 28 }}>
            <Link to="/" className="btn btn-primary">Home</Link>
            <Link to="/news" className="btn btn-ghost">News</Link>
            <Link to="/admission" className="btn btn-ghost">Admission</Link>
            <Link to="/contact" className="btn btn-ghost">Contact</Link>
          </div>
        </div>
      </section>
    </>
  );
}
